import { create } from "zustand";
import { leitenPrimitive } from "../../leiten/controllers/leitenPrimitive";
export const useRecaptchaStore = create(() => ({
    captchaTokenV3: null,
    captchaTokenV2: null,
}));
export const captchaTokenV3Controller = leitenPrimitive(useRecaptchaStore, "captchaTokenV3");
export const captchaTokenV2Controller = leitenPrimitive(useRecaptchaStore, "captchaTokenV2");
export const reCaptchaV2Callback = (token) => {
    if (typeof token === "string") {
        captchaTokenV2Controller.set(token);
    }
};
export const reCaptchaV3Callback = (token) => {
    if (typeof token === "string") {
        captchaTokenV3Controller.set(token);
    }
};
